import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import { ProjectKeywordGq, ProjectKeywordGqProps } from '../../models/ProjectKeywordGq';

export function useGetTopKeywordsGq(command: CommandGq) {
  const query = useCustomQuery<DataGq, VariablesGq>(gqTag, {
    variables: { command },
    fetchPolicy: 'cache-and-network',
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getTopKeywords,
  };
}

export const gqTag = gql`
  query GetTopKeywords($command: GetTopKeywordsCommand!) {
    projects {
      getTopKeywords(command: $command) {
        topKeywords {
          id
          name
          keywords {
            ${ProjectKeywordGqProps} 
          }
        }
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getTopKeywords: ResponseGq;
  };
}

export interface ResponseGq {
  readonly topKeywords?: TopKeywordsGq[];
}

export interface TopKeywordsGq {
  readonly id: number;
  readonly name: string;
  readonly keywords: ProjectKeywordGq[];
}

export interface VariablesGq {
  readonly command: CommandGq;
}
export interface CommandGq {
  readonly projectId: number;
  readonly tagGroupIds: number[];
  readonly limitItems: number;
  readonly serpOnly: boolean;
}
